__turbopack_context__.v({
  "actionButton": "field-module__djbVuG__actionButton",
  "actionButtons": "field-module__djbVuG__actionButtons",
  "blockLabel": "field-module__djbVuG__blockLabel",
  "bottomText": "field-module__djbVuG__bottomText",
  "circular": "field-module__djbVuG__circular",
  "contentBefore": "field-module__djbVuG__contentBefore",
  "disabled": "field-module__djbVuG__disabled",
  "error": "field-module__djbVuG__error",
  "field": "field-module__djbVuG__field",
  "fieldWrapper": "field-module__djbVuG__fieldWrapper",
  "filled": "field-module__djbVuG__filled",
  "hasError": "field-module__djbVuG__hasError",
  "hasFocus": "field-module__djbVuG__hasFocus",
  "input": "field-module__djbVuG__input",
  "inputWrapper": "field-module__djbVuG__inputWrapper",
  "label": "field-module__djbVuG__label",
  "labelLarge": "field-module__djbVuG__labelLarge",
  "labelMedium": "field-module__djbVuG__labelMedium",
  "labelSmall": "field-module__djbVuG__labelSmall",
  "labelToPlaceholder": "field-module__djbVuG__labelToPlaceholder",
  "large": "field-module__djbVuG__large",
  "medium": "field-module__djbVuG__medium",
  "normalLabel": "field-module__djbVuG__normalLabel",
  "note": "field-module__djbVuG__note",
  "noteWrapper": "field-module__djbVuG__noteWrapper",
  "open": "field-module__djbVuG__open",
  "outline": "field-module__djbVuG__outline",
  "small": "field-module__djbVuG__small",
  "square": "field-module__djbVuG__square",
  "underline": "field-module__djbVuG__underline",
});
